// extracted by mini-css-extract-plugin
export default {"budget_tb":"ROCITable_budget_tb__L8RZE","budget_tb2":"ROCITable_budget_tb2__2oYUF","budget_tb3":"ROCITable_budget_tb3__-5ajH"};